



























































































import { Component, Prop, Vue } from 'vue-property-decorator';

import {
  ThreatLevel,
  ThreatWithQuestions,
} from '../models';

@Component
export default class SingleThreat extends Vue {
  @Prop(Object) private readonly threat!: ThreatWithQuestions;

  private ThreatLevel = ThreatLevel;
}
